var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"overflow":"hidden","width":"1585px","margin-left":"150px"}},[_c('iframe',{staticClass:"frame",attrs:{"src":_vm.url,"frameborder":"0","width":"1600","id":"iframepage"},on:{"load":_vm.changeFrameHeight}})])}
var staticRenderFns = []

export { render, staticRenderFns }